<template lang='pug'>
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items="items"
  item-value='id'
  item-text='name'
  :label="label"
)
  template(v-slot:selection='{item}')
    div(:style="'width: 20px; height: 20px; border: 1px solid #000000; background-color: ' + item.id + ''")
    div(style="margin-left: 10px") {{ item.name }}
  template(v-slot:item='{item}')
    div(:style="'width: 20px; height: 20px; border: 1px solid #000000; background-color: ' + item.id + ''")
    div(style="margin-left: 10px") {{ item.name }}     
</template>

<script>
import picker from '@/mixins/picker'

export default {
  mixins: [picker],
  props: ['items','label'],

}
</script>
